import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AccountService {
  private newAccount = new BehaviorSubject<string>(undefined);
  newAccount$ = this.newAccount.asObservable();

  public getNewAccount(): string {
    return this.newAccount.value;
  }

  public setNewAccount(value: string) {
    this.newAccount.next(value);
  }

  public removeNewAccount() {
    this.newAccount.next(undefined);
  }
}
